import React, { Component } from "react";
import { EditorState, convertToRaw } from "draft-js";
import { Button, Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import EditorComponent from "./EditorComponent";
import LoadingOverlay from "@/views/Components/LoadingOverlay";
import { handleError } from "@/util/errorHandler";
import swal from "sweetalert2";
import propertiesApi from "@/api/properties";
import { htmlToState, stateToHtml } from "./converters";

class Desktop extends Component {
  state = {
    isLoading: false,
    isTextChanged: false,
    isTextValid: false,
    oldValue: EditorState.createEmpty(),
    editorState: EditorState.createEmpty(),
  };

  async componentDidMount() {
    await this.fetchCurrentState();
    if (this.state.editorState.getCurrentContent().hasText()) {
      this.setState({
        isTextValid: true,
      });
    } else {
      this.setState({
        isTextValid: false,
      });
    }
  }

  componentDidUpdate(
    prevProps,
    { editorState: prevEditorState, isLoading: wasLoading },
  ) {
    const { isTextChanged, editorState, isTextValid, oldValue } = this.state;
    const newText = convertToRaw(editorState.getCurrentContent())
      .blocks.map(block => block.text)
      .join("");
    const oldText = convertToRaw(oldValue.getCurrentContent())
      .blocks.map(block => block.text)
      .join("");

    if (
      this.state.editorState.getCurrentContent().hasText() &&
      newText &&
      oldText
    ) {
      if (!wasLoading && !isTextChanged && newText !== oldText) {
        this.setState({
          isTextChanged: true,
          isTextValid: true,
        });
      } else {
        if (newText === oldText) {
          if (
            (isTextChanged && isTextValid) ||
            (!isTextChanged && !isTextValid)
          ) {
            this.setState({
              isTextChanged: false,
              isTextValid: true,
            });
          }
        }
      }
    } else {
      if (
        !this.state.editorState.getCurrentContent().hasText() &&
        isTextValid
      ) {
        this.setState({
          isTextValid: false,
          isTextChanged: false,
        });
      } else {
        if (
          this.state.editorState.getCurrentContent().hasText() &&
          newText &&
          !oldText &&
          !isTextValid &&
          !isTextChanged
        ) {
          this.setState({
            isTextValid: true,
            isTextChanged: true,
          });
        }
      }
    }
  }

  fetchCurrentState = async () => {
    try {
      this.setState({ isLoading: true });

      const { termConditionDesktop } = await propertiesApi.getProperties();

      if (termConditionDesktop) {
        this.setState({
          editorState: htmlToState(termConditionDesktop),
          oldValue: htmlToState(termConditionDesktop),
        });
      }
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false, isTextChanged: false });
    }
  };

  onChangeEditorState = editorState => this.setState({ editorState });

  onAttemptToSaveChanges = async () => {
    const { value } = await swal({
      title: "Confirmation needed",
      text: "Do you want to change T&C for desktop?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Change",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (value) {
      this.saveChanges();
    }
  };

  saveChanges = async () => {
    try {
      this.setState({ isLoading: true });

      const text = stateToHtml(this.state.editorState);

      await propertiesApi.sendTermsAndConditionsDesktop(text);
      await swal(
        "Success",
        "T&C for desktop has been successfully changed",
        "success",
      );
      this.fetchCurrentState();
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false, isTextChanged: false });
    }
  };

  render() {
    const { isLoading, isTextChanged, isTextValid, editorState } = this.state;

    return (
      <Card>
        <LoadingOverlay loading={isLoading} />
        <CardHeader>Edit Terms and Conditions for Desktop users</CardHeader>
        <CardBody>
          <EditorComponent
            editorState={editorState}
            onChangeEditorState={this.onChangeEditorState}
          />
        </CardBody>
        <CardFooter
          style={{
            textAlign: "right",
          }}>
          <Button
            color="primary"
            onClick={this.fetchCurrentState}
            disabled={!isTextChanged}>
            Discard changes
          </Button>
          <Button
            color="success"
            data-cy="save"
            onClick={this.onAttemptToSaveChanges}
            style={{ width: 90, marginLeft: "10px" }}
            disabled={!isTextValid || !isTextChanged}>
            Save
          </Button>
        </CardFooter>
      </Card>
    );
  }
}

export { Desktop };
